import { Component, OnInit } from '@angular/core';
import { FeedbackStatusSFSyncService } from '../service/feedback-status-sf-sync.service';
import { FileStatusModel } from '../model/file-status.model';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { UserService } from '../shared/user.service';

@Component({
  selector: 'feedback-status-sf-sync',
  templateUrl: './feedback-status-sf-sync.component.html',
  styleUrls: ['./feedback-status-sf-sync.component.css']
})
export class FeedbackStatusSFSyncComponent implements OnInit {

  userDetails: any;
  accountManagers: any[];
  accountManagerSelected: any = null;
  customers: any[];
  customerSelected: any = null;
  resultTable: any[] = null;
  cols: any[];
  msgs: Message[] = [];
  statusAges: any[];
  statusAgeSelected: any;

  constructor(private dataService: FeedbackStatusSFSyncService, private router: Router, private userService: UserService) { }

  ngOnInit() {
    

    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;
      if (!this.userDetails.ClientRoleAdministration && !this.userDetails.ClientRoleSupport && !this.userDetails.ClientRoleSemiAdministrator) {
        return this.showMessage('error', '', 'אינך מורשה למסך זה ');
      }
      this.getData();

      
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בבדיקת הרשאות ');
    });

   
    this.cols = [
      { field: 'Id', header: 'מזהה שידור' },
      { field: 'Counter', header: 'מספר נסיונות' },
      { field: 'CustomerNumber', header: 'מעסיק' },
      { field: 'CustomerName', header: 'שם מעסיק' },
      { field: 'MISPAR_MEZAHE_OVED', header: 'ת.ז. עובד' },
      { field: 'SHEM_PRATI', header: 'שם פרטי' },
      { field: 'SHEM_MISHPACHA', header: 'שם משפחה' },
      { field: 'CHODESH_MASKORET', header: 'חודש שכר' },
      { field: 'ReportMonth', header: 'חודש דיווח' },
      // { field: 'StatusDescriptionShort', header: 'סטטוס' },
      { field: 'CreateDate', header: 'תאריך יצירת שידור' },

    ];
  }


  getData(): void {
    

    this.dataService.getData().subscribe((result: any) => {
      this.resultTable = result;
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת נתונים ');
    });
  }

  

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }



}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/feedback-status-sf-sync/feedback-status-sf-sync.component.ts